export const DATA_TABLE_CLASSES = {
  table: "w-full border-collapse text-[13px]",
  headRow:
    "text-left text-[12px] font-bold tracking-normal text-(--text-muted)",
  th: "px-4 pb-[14px] pt-0 border-b border-(--border-subtle) whitespace-nowrap",
  thRight:
    "px-4 pb-[14px] pt-0 text-right border-b border-(--border-subtle) whitespace-nowrap",
  bodyRow: "border-b border-(--border-subtle) hover:bg-(--surface-2)",
  td: "px-4 py-[18px] align-middle text-(--text-primary)",
  tdRight: "px-4 py-[18px] align-middle text-right",
  emptyCell: "px-4 py-8 text-center text-[13px] text-(--text-secondary)",
};

export default function DataTable({ children, className = "" }) {
  return (
    <div className={`w-full ${className}`.trim()}>
      <div className="w-full overflow-x-auto">
        <table className={DATA_TABLE_CLASSES.table}>{children}</table>
      </div>
    </div>
  );
}
